import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FaqData } from "../interface";
import { getFaqs } from "../utils/faq";

const Faqs: React.FC<{ onSend: Function }> = ({ onSend }) => {
  const [faqList, setFaqList] = useState<FaqData[][]>([]);

  useEffect(() => {
    getFaqList();
  }, []);

  const getFaqList = async () => {
    const faqs = await getFaqs();
    if (Array.isArray(faqs) && faqs.length > 0) {
      const faqs2d = faqs
        .slice(0)
        .map((_, i) => faqs.slice(i * 2, (i + 1) * 2))
        .filter((faq) => faq.length > 0);
      setFaqList(faqs2d);
    }
  };

  const handleSend = (text: string) => {
    onSend(text);
  };

  const responsiveCarousel = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 2,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 950 },
      items: 2,
      slidesToSlide: 1,
    },
    smallLaptop: {
      breakpoint: { max: 950, min: 650 },
      items: 1.5,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 650, min: 520 },
      items: 1.2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 520, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  if (faqList.length === 0) return null;

  return (
    <div>
      <p className="faq-header">
        Here are some quick suggestions for you to get started
      </p>
      <Carousel
        responsive={responsiveCarousel}
        containerClass="carousel-container"
      >
        {faqList.map((faq, i) => {
          return (
            <div className="faq-group" key={i}>
              {faq.map((faqItem, j) => {
                return (
                  <button
                    onClick={() => handleSend(faqItem.message)}
                    className="faq-container"
                    key={i + j}
                  >
                    <p className="faq-content-header" key={Math.random()}>
                      <b>{faqItem.title}</b>
                    </p>
                    <p className="faq-content-text" key={Math.random()}>
                      {faqItem.message}
                    </p>
                  </button>
                );
              })}
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};

export default Faqs;
